import {MdPerson} from 'react-icons/md'
import logout from '@helpers/auth/logout'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'

import HR from '../HR'
import {ReservationLabel} from '../Label'
import {useCreateReservationContext} from '../ReservationContext'

export default function LoggedIn() {
  const {firstName, lastName, email, phone} = useCreateReservationContext()
  const isDarkMode = useIsDarkMode()

  return (
    <div className="space-y-2">
      <ReservationLabel className="mt-1">
        Estás usando esta cuenta, pero puedes{' '}
        <a onClick={() => logout()} className="text-gray-600 underline">
          cerrar sesión
        </a>
      </ReservationLabel>
      <div
        className={classnames('px-3 py-2 rounded-lg space-y-2', {
          'bg-gray-700': isDarkMode,
          'bg-gray-100': !isDarkMode
        })}>
        <div className="flex items-center space-x-2">
          <span className="bg-gray-400 h-8 w-8 rounded-full flex items-center justify-center">
            <MdPerson className="h-5 w-5 text-white" aria-hidden="true" />
          </span>
          <div>
            <div className="text-sm">
              {firstName} {lastName}
            </div>
            <div
              className={classnames('text-sm', {
                'text-gray-300': isDarkMode,
                'text-gray-600': !isDarkMode
              })}>
              {email}, {phone}
            </div>
          </div>
        </div>
      </div>
      <div className="pt-3 pb-1">
        <HR />
      </div>
    </div>
  )
}
